import React, { useState, createRef, useRef,useEffect } from "react";
import SunEditor, { buttonList }  from "suneditor-react";
import {Article} from "../../data/types";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Page404 from "app/not-found";
import MediaVideo from "../../components/PostFeaturedMedia/MediaVideo";
import Link from "../../components/Link";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { fr } from 'date-fns/locale/fr';
registerLocale('fr', fr)

const API_URL = "https://ahuncycle-backend.vercel.app";
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageAjouterVideo = () => {
    const { user } = useSelector((state) => state.user);
    const editorRef = createRef();
    const [contents, setContents] = useState(null);
    const [categorie, setCategorie] = useState('Articles');
    const [videoUrl, setVideoUrl] = useState("");
    const [createdAt, setCreatedAt] = useState(new Date());
    const [date, setDate] = useState(getDate());
    const [description, setDescription] = useState("");
    const [href, setHref] = useState("");
    const [titre, setTitre] = useState("");
    const [isHover, setIsHover] = useState(false);
   

    function getDate() {
        
        var date = new Date()
        const month = ["janvier","février","mars","avril","mai","juin","juillet","août","septembre","obtobre","novembre","décembre"];
        let jour = date.getDate();
        let mois =  month[date.getMonth()];
        let annee = date.getFullYear();
        return jour + " " + mois + " " + annee;
    };

    const categorieChange = (e) => 
    {
        e.preventDefault();
        setCategorie(()=>e.target.value)
    };

    function youtube_parser(url){
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match&&match[7].length==11)? match[7] : false;
    }
    
    const saveArticle= async (html) =>
    {
        if (!(document.querySelector("#titre").value=="" ||
            document.querySelector("#videoUrl").value=="" ||
            document.querySelector("#description").value=="" ||
            document.querySelector("#date").value=="") ||
            document.querySelector("#creationDate").value=="")
        {
        try 
        {
            
            let video = youtube_parser(document.querySelector("#videoUrl").value);
           
            const form = new FormData();
            form.append("id", "1");
            form.append("image", "https://img.youtube.com/vi/"+video+"/hqdefault.jpg");
            form.append("title", document.querySelector("#titre").value);
            form.append("desc", document.querySelector("#description").value);
            form.append("date", document.querySelector("#date").value);
            form.append("href","/video/"+video);
            form.append("categorie",document.querySelector("#categorie").value);
            form.append("videoUrl",document.querySelector("#videoUrl").value);
            form.append("createdAt",document.querySelector("#createdAt").value);
          
            const response = await axiosInstance.post("api/videos", form);
           
            alert("Enregistrement réussi!");
            window.location.reload();
        
        }
        catch (error) 
        {
            alert(error);
            return;
        }
    }
    else
    {
        alert("Vous devez entrer tous les champs");
        return
    }   
    }
   
    const titreChange = (e) => 
    {
        e.preventDefault();
        setTitre(()=>e.target.value);            
    };

    const videoUrlChange = (e) => 
    {
        e.preventDefault();
        setVideoUrl(()=>e.target.value);         
    };
  
    const dateChange = (e) => 
    {
        e.preventDefault();
        setDate(()=>e.target.value);
    };

    const descriptionChange = (e) => 
    {
        e.preventDefault();
        setDescription(()=>e.target.value);
    };

if (Object.keys(user).length===0)
    return (<Page404 />)
else
    return (
<>
      <div>
        <form name="frm">
        <table>
            <tbody>
                <tr>
                    <td><p>Catégorie:</p></td>
                    <td>
                        <select name="categorie" id="categorie" onChange={categorieChange} value={categorie}>
                            <option value="Événements">Événements</option>
                            <option value="Propositions">Propositions</option>
                            <option value="Évenements">Événements</option>
                            <option value="Conseils">Conseils d'arrondissement</option>
                            <option value="Photos">Photos</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td><p>Titre:</p></td>
                    <td>
                        <input value={titre} style={{width:"600px"}} type="text" name="titre" id="titre" onChange={titreChange}/>
                    </td>
                </tr>
                <tr>
                    <td><p>URL:</p></td>
                    <td><input id="videoUrl" name="videoUrl" style={{width:"100%"}} type="text"  value={videoUrl} onChange={videoUrlChange}/></td>
                    <td><p>Date:</p></td>
                    <td><p><input id="date" name="date" value={date} type="text" onChange={dateChange} /></p></td> 
                </tr>
                <tr>
                    <td><p>Description:</p></td>
                    <td ><input id="description" name="description" value={description} style={{width:"100%"}} type="text" onChange={descriptionChange} /></td>
                    <td><p>Date création:</p></td>
                    <td><p><DatePicker id="createdAt" name="createdAt" style={{width:"100px"}} locale="fr" selected={createdAt} onChange={(date) => setCreatedAt(date)} /></p></td> 
           
                </tr>
                <tr>
                    <td colspan="4" align="center">
                    <button type="button"
                        onClick={saveArticle}
                        className="boutonDownload"
                        >Enregistrer</button>
                    </td>
                </tr>
            </tbody>
        </table>
        </form>
      </div>
      <div style={{width:"400px", height:"300px"}} className="nc-Card10V2 relative flex flex-col"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}>
        <b>{titre}</b>
       <div className="block group rounded-3xl flex-shrink-0 relative w-full aspect-w-16 aspect-h-12 sm:aspect-h-9 overflow-hidden z-0">
          <div>
            <MediaVideo isHover videoUrl={videoUrl} />;
          </div>
          <Link
              href={href}
              className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 transition-opacity"
              >
          </Link>
      </div>
      {description}<br></br>
      {date}<br></br>
  </div>
  </>
    )
}

export default PageAjouterVideo;